// ═══════════════════════════════════════════════════════════════════════
// data/menuItems.js — menu_items table access (extracted from App.js)
// ═══════════════════════════════════════════════════════════════════════
// Thin Supabase wrappers for the Price-Tool menu CRUD. Behaviour-identical to
// the previous inline queries: each returns the raw Supabase `{ data, error }`
// result so callers keep handling errors exactly as before. RLS is the guard.
import { supabase } from "../lib/supabaseClient";

export function upsertMenuItem(payload) {
  return supabase.from("menu_items").upsert(payload).select().single();
}

export function deleteMenuItem(id) {
  return supabase.from("menu_items").delete().eq("id", id);
}
